export default "__VITE_ASSET__044908fc__"